// extracted by mini-css-extract-plugin
export var base = "_4c-0";
export var updateBanner = "_4c-1";